/**
 * 运行监测组件
 */
import { Style } from '@/libs/style.js';
import Chance from '@/utils/chance.js'
import Capsule from '@/components/charts/capsule-line'

let template = /*html*/ `<div class="run-monitoring">
    <div class="run-monitoring-header">
        <img src="./images/default/2.png" alt="">
        <h2>出水质监测</h2>
        <dv-decoration-1 style="width:200px;height:100%;position:absolute;right:0;" />
    </div>
    <div class="run-chart-pie">
      <!--<dv-charts :option="option" />-->
      <!--<dv-capsule-chart :config="config" style="width:100%;height:100%;margin-top:10px;" />-->
      <capsule-line :config="JSON.stringify(config)"/>
      

    </div>
    <!--<dv-capsule-chart-1 :config="JSON.stringify(config)" style="width:10%;height:200px;" />-->
    
</div>`;

const $Chance = new Chance()
let style = /* css */ `.run-monitoring{
    position: absolute;
    top: 0%;
    left: 1%;
    width: 25%;
    background: rgba(0,0,0,0.2);
    height: 30%;
    overflow: hidden;
    
}

.run-monitoring .run-monitoring-header{
  background:linear-gradient(to right,#159AFF,rgba(0,0,0,0) 100%);
    height: 50px;
    color: #fff;
    display:flex;
    align-items:center;
    position:relative;
}
.run-monitoring .run-monitoring-header img{
    margin:0 15px;
}
.run-monitoring .run-chart-pie{
  height:85%;
}
.dv-capsule-chart{
  padding-right: 30px;
}
.run-monitoring .unit-label{
  opacity:0;
}
`;

export default (Vue) => {
  Vue.customElement('xbt-run-monitoring', {
    template: template,
    data() {
      return {
        config: {},
        option: {
          color: ['#cc6666', '#008585', '#4D74FF', '#FFD982', '#5AF3B8'],
          series: [
            {
              data: [
                { name: 'COD', value: 167 },
                { name: '氨氮', value: 1.2 },
                { name: 'TP', value: 98 },
                { name: 'pH', value: 7.5 },
                { name: 'TM', value: 66 },
                { name: 'SS', value: 6 },],
              insideLabel: {
                show: true,
                formatter: (dataItem) => {
                  return '' + dataItem.name
                },
                style: {
                  fontSize: 16
                }
              },
              outsideLabel: {
                show: true,
                formatter: (dataItem) => {
                  return '' + dataItem.value
                },
                style: {
                  fontSize: 20
                }
              },

              type: 'pie',
              animationCurve: 'easeOutBack',
              barWidth: 10,
              radius: ['45%', '65%'],
              showOriginValue: true

            }
          ]
        },
      }
    },
    created() {
      this.setConfig()
      Capsule()
    },
    mounted() {
      Style(style);
      setInterval(() => {
        this.option = {
          color: ['#cc6666', '#008585', '#4D74FF', '#FFD982', '#5AF3B8'], series: [
            {
              data: [
                { name: 'COD', value: this.randomCount(90, 100) },
                { name: '氨氮', value: this.randomCount(0, 10) },
                { name: 'TP', value: this.randomCount(1, 10) },
                { name: 'pH', value: this.randomCount(7, 7.5) },
                { name: 'TM', value: this.randomCount(10, 60) },
                { name: 'SS', value: this.randomCount(0.1, 5, 2) },],
              insideLabel: {
                show: true,
                formatter: (dataItem) => {
                  return '' + dataItem.name
                },
                style: {
                  fontSize: 16
                }
              },
              outsideLabel: {
                show: true,
                formatter: (dataItem) => {
                  return '' + dataItem.value
                },
                style: {
                  fontSize: 20
                }
              },

              type: 'pie',
              animationCurve: 'easeOutBack',
              barWidth: 10,
              radius: ['45%', '65%'],
              showOriginValue: true

            }
          ]
        }


        // this.config = {
        //   data: [
        //     { name: 'COD', value: this.randomCount(90, 100),max:200,min:90},
        //     { name: '氨氮', value: this.randomCount(0, 10),max:10,min:0 },
        //     { name: 'TP', value: this.randomCount(1, 10) ,max:10,min:0},
        //     { name: 'pH', value: this.randomCount(7, 7.5)  ,max:14,min:0},
        //     { name: 'TM', value: this.randomCount(10, 60) ,max:60,min:0 },
        //     { name: 'SS', value: this.randomCount(0, 5) ,max:5,min:0 }
        //   ],
        //   colors: ['#e062ae', '#fb7293', '#e690d1', '#32c5e9', '#96bfff'],
        //   unit: '',
        //   xAxis: {
        //     axisLabel: {
        //       show: false
        //     }
        //   },
        //   showValue: true
        // }
      }, 5500)
      
    },
    methods: {
      setConfig() {
        let runActionConfig = JSON.parse(localStorage.runActionConfig || null);
        if (!runActionConfig) {
          runActionConfig = {
            time: Date.now(),
            data: this.createConfig()
          }
        }
        // 大于两个小时更新
        if (Date.now() - runActionConfig.time > 7200000) {
          runActionConfig.data = this.createConfig();
          runActionConfig.time = Date.now();
        }
        localStorage.runActionConfig = JSON.stringify(runActionConfig);
        this.config = Object.assign({},runActionConfig.data);
        console.log(this.config)
      },

      createConfig() {
        return {
          data: [
            { name: 'COD', value: this.randomCount(0, 100), max: 100, min: 0 },
            { name: '氨氮', value: this.randomCount(0, 10, 1), max: 10, min: 0 },
            { name: 'TP', value: this.randomCount(1, 10), max: 10, min: 0 },
            { name: 'pH', value: this.randomCount(7, 7.5, 1), max: 14, min: 0 },
            { name: 'TM', value: this.randomCount(10, 60), max: 60, min: 0 },
            { name: 'SS', value: this.randomCount(0, 5, 2), max: 5, min: 0 }
          ],
          colors: ['#e062ae', '#fb7293', '#e690d1', '#32c5e9', '#96bfff'],
          unit: '',

          showValue: true
        }
      },
      randomCount(min, max, fixed = 0) {
        let num = $Chance.floating({ min, max, fixed: fixed })
        return num
      }
    }
  });
}